export default __webpack_public_path__ + "static/media/shirt.69da17f6.jpg";